import { Loader } from "@mantine/core";
import { Building2 } from "lucide-react";

const LoadWorkspace = () => (
  <div className="fixed inset-0 flex flex-col items-center justify-center z-50 bg-background">
    <div className="flex flex-col items-center gap-6 max-w-sm text-center px-6">
      <div className="h-12 w-12 rounded-xl bg-primary/10 flex items-center justify-center">
        <Building2 className="h-6 w-6 text-primary" />
      </div>
      <div className="flex flex-col gap-2">
        <h2 className="text-lg font-semibold text-foreground">
          Setting up your workspace
        </h2>
        <p className="text-sm text-muted-foreground">
          We're configuring everything for you. This will only take a moment.
        </p>
      </div>
      <Loader size="sm" color="var(--color-primary)" />
    </div>
  </div>
);

export default LoadWorkspace;
